export function toCents(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 100);
}

/**
 * True when the ledger is current: zero or a credit (not owed).
 * property-lease-summary uses positive balance for credit, negative for amount owed.
 * A payment just before the 25th can leave balance at $0 while still
 * looking "unpaid this cycle."
 */
export function hasNonNegativeBalance(property) {
  const cents = toCents(property?.balance);
  if (cents == null) return false;
  return cents >= 0;
}

/**
 * True when the ledger credit is at least one month of base rent.
 */
export function hasOneMonthRentCredit(property) {
  const creditCents = toCents(property?.balance);
  const rentCents = toCents(property?.monthlyBaseRent);
  if (creditCents == null || rentCents == null || rentCents <= 0) {
    return false;
  }
  return creditCents >= rentCents;
}
